const entrepreneurOfYear = require.context('./static/img/entrepreneur-of-year');
const financialWorld = require.context('./static/img/financial-world');
const hedgeFund = require.context('./static/img/hedge-fund');
const privateInvestor = require.context('./static/img/private-investor');
const youngEntrepreneur = require.context('./static/img/young-entrepreneur');

export const getAwards = (t: Function) => [
  {
    logo: hedgeFund,
    title: t('Best Hedge Fund 2015'),
    details: t('Best Hedge Fund 2015 details'),
  },
  {
    logo: privateInvestor,
    title: t('Best Private Investor 2011 2012'),
    details: t('Best Private Investor 2011 2012 details'),
  },
  {
    logo: youngEntrepreneur,
    title: t('Best Young Entrepreneur 2010'),
    details: t('Best Young Entrepreneur 2010 details'),
  },
  {
    logo: financialWorld,
    title: t('Global Finance Award 2012'),
    details: t('Global Finance Award 2012 details'),
  },
  {
    logo: entrepreneurOfYear,
    title: t('Entrepreneur of the Year for 2012'),
    details: t('Entrepreneur of the Year for 2012 details'),
  },
];
